
import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TransitRulingPlanet } from './TransitRulingPlanet';
import { TransitPlanetChart } from './TransitPlanetChart';
import { TransitCuspalChart } from './TransitCuspalChart';
import { useMemo, useState } from 'react';
import { RashiChart } from './RashiChart';

export function TransitChartTab ({menuArray,userData,clientData,transitData}) {
  const [birthChartType, setBirthChartType] = useState('0');
  const [data, setData] = useState();
  useMemo(() => {
    setBirthChartType(transitData.birthChart.birthChartType);
    setData( {
        firstName:"",
        lastName:"",
        birthDate: transitData.date,
        birthDay: transitData.day,
        birthTimeCorrected: transitData.time,
        birthTime: transitData.time,
        birthTimezone: transitData.timezone,
        birthCity: transitData.city,
        birthLatitude: transitData.latitude,
        birthLongitude: transitData.longitude,
      });
  },[transitData])

  return(
    <Collapse in={menuArray[0]} className="m-0 p-0 ">
      <Row id="transitChartTab" className="m-0 p-0">
        <Col xs={12} lg={4} className="m-0 p-2 pt-0">
        { data===null||data===undefined?<></>:
          <RashiChart birthHouseData={transitData.birthChart.house} userData={data} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType} kpenabled={true}/>
        }
        </Col>
        <Col xs={12} lg={8} className="m-0 p-2 pt-0">
          <Row id="transitChartTab2" className="m-0 p-0">
            <Col xs={0} lg={6} className="m-0 p-0 ps-1 pe-1">
              <TransitPlanetChart transitData={transitData}/>
            </Col>
            <Col xs={0} lg={6} className="m-0 p-0 ps-1 pe-1">
              <TransitCuspalChart transitData={transitData}/>
            </Col>
          </Row>
          <Row id="transitChartTab2" className="m-0 p-0">
            <Col xs={0} className="m-0 p-0 ps-1 pe-1">
              <TransitRulingPlanet clientData={clientData}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </Collapse>
    );
}